import { URLS } from 'api/constants';
import { ICasino, ISlotReview } from 'constants/types';
import { apiGet, apiGetSafe } from './client';
import { PaginationRequest, PaginationResponse } from './types';

export interface CasinoListParams extends PaginationRequest {
  ids?: string[];
  collections?: string;
  countries?: string | null;
  licenses?: string | null;
  software?: string | null;
  high_rtp?: boolean;
  average_rtp?: boolean;
  low_rtp?: boolean;
  trusted?: boolean;
  blacklisted?: boolean;
  crypto?: boolean;
  player_ratings?: string;
  rtp?: string;
  searchQuery?: string;
}

function buildCasinoParams(params: CasinoListParams) {
  const {
    page,
    limit,
    sortBy,
    countries,
    collections,
    licenses,
    software,
    high_rtp,
    average_rtp,
    low_rtp,
    trusted,
    blacklisted,
    crypto,
    player_ratings,
    rtp,
    searchQuery,
  } = params;

  return {
    sortBy,
    page,
    limit,
    countries,
    collections,
    licenses,
    software,
    hight_rtp: high_rtp,
    average_rtp,
    low_rtp,
    trusted,
    blacklisted,
    crypto,
    player_ratings,
    rtp,
    searchQuery,
  };
}

export async function listCasinos(params: CasinoListParams = {}) {
  const { ids } = params;

  if (ids?.length) {
    return apiGet<PaginationResponse<ICasino>>(
      `${URLS.CASINOS}${ids.join(',')}`
    );
  }

  return apiGet<PaginationResponse<ICasino>>(
    URLS.CASINOS,
    buildCasinoParams(params)
  );
}

export async function getCasinoById(id?: string) {
  const data = await apiGetSafe<ICasino & PaginationResponse<ICasino>>(
    `${URLS.CASINOS}${id ?? ''}`
  );

  if (!data) {
    return null;
  }

  if ('results' in data && Array.isArray(data.results)) {
    return (data.results[0] ?? null) as ICasino | null;
  }

  return (data as ICasino) ?? null;
}

export async function getCasinosByIds(ids?: string) {
  const data = await apiGet<ICasino & PaginationResponse<ICasino>>(
    `${URLS.CASINOS}${ids ?? ''}`
  );

  if (data?.results) {
    return {
      results: data.results,
      count: Number(data.count ?? data.results.length),
    };
  }

  return { results: data ? [data as ICasino] : [], count: 1 };
}

export async function getSlotReviewsByCasino(casinoId: string) {
  return apiGet<PaginationResponse<ISlotReview>>(
    URLS.SLOT_REVIEWS_ALL_BY_CASINO,
    {
      casino_id: casinoId,
      isReviewed: 'true',
    }
  );
}

export async function getCasinosForRealMoney() {
  return apiGet<PaginationResponse<ICasino>>(URLS.CASINOS_FOR_REAL_MONEY);
}

export async function getCasinosBySlot(id: string, countries?: string | null) {
  return apiGet<PaginationResponse<ICasino>>(`${URLS.CASINOS_BY_SLOT}${id}`, {
    countries: countries ?? undefined,
  });
}
